import { render, staticRenderFns } from "./deliveryaddress.vue?vue&type=template&id=229109ee&"
import script from "./deliveryaddress.vue?vue&type=script&lang=js&"
export * from "./deliveryaddress.vue?vue&type=script&lang=js&"
import style0 from "./deliveryaddress.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports